// styles/buttonStyles.ts

export const buttonPrimary =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-blue-600 text-white hover:bg-blue-700";

export const buttonSubmit =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-green-600 text-white hover:bg-green-700";  

export const buttonSave =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-amber-600 text-white hover:bg-amber-700";

export const buttonCancel =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-orange-800 text-white hover:bg-orange-400";

export const buttonReset =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-yellow-600 text-black hover:bg-yellow-700";

export const buttonMarkAll =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-blue-600 text-white hover:bg-blue-700";

export const buttonApprove =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-green-600 text-white hover:bg-green-700";

export const buttonReject =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-amber-600 text-white hover:bg-amber-700";

export const buttonRetry =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-yellow-400 text-white hover:bg-yellow-700";

export const buttonDropDown =
  "px-4 py-2 rounded cursor-pointer text-sm py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-gray-200 text-black hover:bg-gray-300";

export const buttonLink = "px-4 py-2 cursor-pointer text-sm text-underline transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-bold text-blue-700 bg-green-50  hover:bg-blue-300"; 
